import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../../../models/base/base-view-model';
import { UserDomainModel } from '../../../../../domainModels/user-domain-model';
import { BehaviorSubject } from 'rxjs';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class SignOutViewModel extends BaseViewModel {
  constructor(protected router: Router, protected userDomainModel: UserDomainModel) {
    super();
    this.init();
  }

  public loadingOpts$ = new BehaviorSubject<LoadingOptions>(LoadingOptions.default());
  public isLoading$ = this.loadingOpts$.pipe(map(it => it?.isLoading));

  signOut() {
    const loadingMess = 'Signing Out';
    this.loadingOpts$.addRequest(loadingMess);
    return this.userDomainModel.signOut().subscribe({
      complete: () => {
        this.loadingOpts$.removeRequest(loadingMess);
        this.router.navigate(['/auth/sign-in']).then();
      },
      error: () => {
        this.loadingOpts$.removeRequest(loadingMess);
        this.router.navigate(['/auth/sign-in']).then();
      }
    });
  }
}
